module.exports = __webpack_public_path__ + "static/media/menuArrow.cbacf448.svg";